import { Navigate } from 'react-router-dom';
import { firstReadablePath, type SectionId } from '@/lib/section-permissions';
import { useSectionRights } from '@/lib/use-section-rights';

interface Props {
  /** Every listed section must be readable (Lesen). */
  sections: SectionId | readonly SectionId[];
  children: React.ReactNode;
}

/**
 * Route gate for section rights (client #95). Without Lesen on the section the
 * user is sent to the first page they may read. org_admin always passes —
 * admins have every right.
 */
export function RequireSection({ sections, children }: Props) {
  const rights = useSectionRights();
  const list: readonly SectionId[] =
    typeof sections === 'string' ? [sections] : sections;
  if (!list.every(s => rights[s].read)) {
    return <Navigate to={firstReadablePath(rights)} replace />;
  }
  return <>{children}</>;
}

/** Index / unknown routes: land on the first page the user may read. */
export function HomeRedirect() {
  const rights = useSectionRights();
  return <Navigate to={firstReadablePath(rights)} replace />;
}
